import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const AccountManager = React.lazy(
  () => import("../screean/accountManager/account-manager")
);
export function accountManager() {
  return (
    <Route
      path="/account-manager"
      element={
        <ProtectedRoute>
          <ProtectedRoleAccountManager>
            <LazySuspense>
              <AccountManager />
            </LazySuspense>
          </ProtectedRoleAccountManager>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
